export default "__VITE_ASSET__RaQmzcr9__"